export const SET_OFFER_DATA = 'SET_OFFER_DATA';
export const SET_OFFER_REQUEST_ERROR = 'SET_OFFER_REQUEST_ERROR';
export const SET_VDP_LINK = 'SET_VDP_LINK';
